// src/pages/Impressum.jsx
import React from 'react';
import '../styles/Impressum.css';

const Impressum = () => {
    return (
        <div className="impressum-container">
            <h1>Impressum</h1>

            <section className="impressum-section">
                <p><strong>HELLO CHARGE</strong><br />
                    Asiatische Küche (HALAL)</p>

                <p><strong>Inhaber:</strong><br />
                    Hello Charge Restaurant GmbH</p>

                <p><strong>Adresse:</strong><br />
                    Huttenstraße 68<br />
                    10553 Berlin<br />
                    Deutschland</p>

                <p><strong>Kontakt:</strong><br />
                    Telefon: 030-81098009<br />
                    E-Mail: <a href="mailto:hellocharge@yahoo.com">hellocharge@yahoo.com</a></p>

                <p><strong>Steuernummer:</strong><br />
                    130/339/50490</p>

                <p><strong>Inhaltlich verantwortlich gemäß § 10 Absatz 3 MDStV:</strong><br />
                    Hello Charge Restaurant GmbH</p>
            </section>

            <section className="impressum-section">
                <h2>Haftungshinweis</h2>
                <p>
                    Trotz sorgfältiger inhaltlicher Kontrolle übernehmen wir keine Haftung
                    für die Inhalte externer Links. Für den Inhalt der verlinkten Seiten sind
                    ausschließlich deren Betreiber verantwortlich.
                </p>
            </section>
        </div>
    );
};

export default Impressum;
